import { invoke } from '@shared/easyfy.decorators';
import Splide from '@splidejs/splide';

@invoke
export default class BannerComponent {
  static Instance: BannerComponent;
  private static isKevelBanner: boolean = false;

  constructor(isKevelBanner: boolean = false) {
    BannerComponent.Instance = this;
    BannerComponent.isKevelBanner = isKevelBanner;
  }

  onInit() {
    BannerComponent.refreshBannerComponent();
  }

  static refreshBannerComponent = () => {
    const selector = `${BannerComponent.isKevelBanner ? '.kevel' : ''}[data-container="banner-full-slider"]`;
    document.querySelectorAll(selector).forEach((list) => {
      list.classList.add('splide');

      const slider = new Splide(list as HTMLElement, {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        interval: 7000,
        arrows: false,
        snap: true,
        pagination: true,
        mediaQuery: 'min',
        breakpoints: {
          1100: {
            arrows: true,
          },
        },
      });

      slider.mount();

      // Filter out slides that don't have images
      slider.Components.Slides.remove('.splide__slide:has(img.empty)');
    });
  };
}
